module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei2.svg";